const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";

const BASE_ACTION_BUTTON = {
  textTransform: "none",
  height: 40,
  padding: "6px 14px",
  fontWeight: 600,
  minWidth: 96,
};

export const PRIMARY_BUTTON_SX = {
  ...BASE_ACTION_BUTTON,
  backgroundColor: BRAND_GREEN,
  color: "#fff",

  "&:hover": {
    backgroundColor: "#507011",
  },
  "&.Mui-disabled": {
    backgroundColor: "rgba(0,0,0,0.12)",
    color: "rgba(0,0,0,0.26)",
  },
};

export const ACTIONS_HEADER_BTN_SX = {
  minHeight: 42,
  px: 2,
  minWidth: 120,
  borderRadius: "8px",
  border: `1.5px solid rgba(0,51,108,0.22)`,
  color: BRAND_BLUE,
  backgroundColor: "#eef2f8",
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13.5,
  letterSpacing: 0.1,
  transition: "all 0.15s ease",
  "&:hover": {
    backgroundColor: "#e2eaf5",
    borderColor: `rgba(0,51,108,0.45)`,
    boxShadow: "0 2px 8px rgba(0,51,108,0.12)",
  },
};

export const ACTION_MENU_PAPER_SX = {
  mt: 0.75,
  border: `1px solid rgba(0,51,108,0.1)`,
  borderRadius: "12px",
  boxShadow: "0 12px 40px rgba(15,23,42,0.14), 0 2px 8px rgba(15,23,42,0.06)",
  minWidth: 220,
  p: 0.5,
  background: "#ffffff",
  "& .MuiMenuItem-root": {
    fontSize: 13.5,
    fontWeight: 500,
    color: "#1a2e4a",
    minHeight: 40,
    px: 1.75,
    borderRadius: "8px",
    gap: 1.5,
    transition: "background 0.12s ease, color 0.12s ease",
  },
  "& .MuiMenuItem-root:hover": {
    backgroundColor: "#eef2f8",
    color: BRAND_BLUE,
    fontWeight: 600,
  },
  "& .MuiMenuItem-root.Mui-disabled": {
    opacity: 0.35,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 32,
    opacity: 0.8,
  },
  "& .MuiMenuItem-root:hover .MuiListItemIcon-root": {
    opacity: 1,
  },
  "& .MuiListItemText-primary": {
    fontSize: 13.5,
    fontWeight: "inherit",
    color: "inherit",
  },
  "& .MuiDivider-root": {
    my: 0.5,
    borderColor: "rgba(0,51,108,0.07)",
  },
};

export const ACTION_MENU_ICON_SX = {
  minWidth: 36,
};

export const ACTION_MENU_ICON_TONES = {
  add: { color: BRAND_GREEN },
  export: { color: BRAND_BLUE },
  clear: { color: "#B7791F" },
  delete: { color: "#D32F2F" },
  insight: { color: "#0F766E" },
  share: { color: "#0E7490" },
  refresh: { color: "#B7791F" },
  save: { color: BRAND_GREEN },
  mail: { color: "#0E7490" },
};

export const SECONDARY_BUTTON_SX = {
  ...BASE_ACTION_BUTTON,
  backgroundColor: BRAND_BLUE,
  color: "#fff",

  "&:hover": {
    backgroundColor: "#002a59",
  },
  "&.Mui-disabled": {
    backgroundColor: "rgba(0,0,0,0.12)",
    color: "rgba(0,0,0,0.26)",
  },
};
